import { ScheduledAction, Signal } from '@demind-inc/core';
import { TimeFormatType } from '@demind-inc/core';
import dayjs from 'dayjs';
import { formatTimeFromDayjs } from '../../../helpers';

export const resolveScheduleType = (schedule: ScheduledAction): string => {
  if (schedule.eventFrom === 'activity') {
    if (schedule.routineFrom?.routineActivityId) {
      return 'routine';
    } else if (schedule.todoFrom?.taskId) {
      return 'todo';
    } else {
      return 'calendar';
    }
  }

  if (schedule.eventFrom === 'existing_calendar') {
    return 'calendar';
  }
  return schedule.eventFrom!;
};

export const getScheduleId = (schedule: ScheduledAction, fallbackIndex = 0): string =>
  String(schedule.id ?? `plan-${fallbackIndex}`);

export const getTimeRange = (schedule: ScheduledAction, timeFormat: TimeFormatType): string => {
  const start = formatTimeFromDayjs(dayjs(schedule.startDate), timeFormat);
  const end = formatTimeFromDayjs(dayjs(schedule.endDate), timeFormat);

  return `${start} - ${end}`;
};

export const getSignals = (schedule: ScheduledAction): Signal[] => {
  const richContext = schedule.richContext;
  if (!richContext) {
    return [];
  }
  return Array.isArray(richContext.signals) ? richContext.signals : [];
};

export const getContentList = (
  schedule: ScheduledAction
): Array<{ type: string; payload: Record<string, unknown> }> => {
  const richContext = schedule.richContext;
  if (!richContext) {
    return [];
  }

  const rawContent = richContext.content;
  const contentList = rawContent ? (Array.isArray(rawContent) ? rawContent : [rawContent]) : [];

  return contentList.flatMap((content: any) => {
    if (!content || typeof content !== 'object') {
      return [];
    }
    const type = typeof content.type === 'string' ? content.type.trim() : '';
    const payload =
      content.payload && typeof content.payload === 'object' && !Array.isArray(content.payload)
        ? (content.payload as Record<string, unknown>)
        : null;
    if (!type || !payload) {
      return [];
    }
    return [{ type, payload }];
  });
};

export const hasRichContext = (schedule: ScheduledAction): boolean => {
  const signals = getSignals(schedule);
  const contentList = getContentList(schedule);
  const explanation = schedule.description ?? '';
  return contentList.length > 0 || signals.length > 0 || !!explanation;
};
